<div class="setting-row" #settingRow [class.disabled]="!canEditVessel()">
    <div class="row-text num-column" data-cy="exh-gas-setting-table-cylinder-number">
        {{ setting.index }}
    </div>
    <div class="row-text temp-column">
        <ng-container *ngIf="setting.tempChannel">
            <div class="channel-text" data-cy="exh-gas-setting-table-temp-channel-name" (click)="selectChannel(TEMP)">
                {{ getChannelName(TEMP) }}
            </div>
            <div class="clear-wrapper" data-cy="exh-gas-setting-table-temp-clear-button" (click)="removeChannel(TEMP)">
                <mat-icon svgIcon="delete" class="icon" />
                <div class="channel-text clear">
                    {{ 'exhaust-setting.clear' | translate }}
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="!setting.tempChannel">
            <div class="disabled-text">
                {{ 'exhaust-setting.select.none' | translate }}
            </div>
            <div
                class="channel-text error-button"
                data-cy="exh-gas-setting-table-temp-select-channel-button"
                (click)="selectChannel(TEMP)">
                {{ 'exhaust-setting.select' | translate }}
            </div>

            <div class="error-icon">
                <mat-icon
                    svgIcon="save-error"
                    (mouseenter)="updateInfoMessage(TEMP)"
                    (mouseleave)="isTempMessageVisible = false" />
                <ng-container *ngIf="isTempMessageVisible">
                    <ng-container *ngTemplateOutlet="infoMessage"></ng-container>
                </ng-container>
            </div>
        </ng-container>
    </div>
    <div class="row-text deviation-column">
        <ng-container *ngIf="setting.deviationChannel">
            <div
                class="channel-text"
                data-cy="exh-gas-setting-table-dev-channel-name"
                (click)="selectChannel(DEVIATION)">
                {{ getChannelName(DEVIATION) }}
            </div>
            <div class="clear-wrapper" (click)="removeChannel(DEVIATION)">
                <mat-icon svgIcon="delete" class="icon" />
                <div class="channel-text clear">
                    {{ 'exhaust-setting.clear' | translate }}
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="!setting.deviationChannel">
            <div class="disabled-text">
                {{ 'exhaust-setting.select.none' | translate }}
            </div>
            <div
                class="channel-text error-button"
                data-cy="exh-gas-setting-table-dev-select-channel-button"
                (click)="selectChannel(DEVIATION)">
                {{ 'exhaust-setting.select' | translate }}
            </div>
            <div class="error-icon">
                <mat-icon
                    svgIcon="save-error"
                    (mouseenter)="updateInfoMessage(DEVIATION)"
                    (mouseleave)="isDevMessageVisible = false" />
                <ng-container *ngIf="isDevMessageVisible">
                    <ng-container *ngTemplateOutlet="infoMessage"></ng-container>
                </ng-container>
            </div>
        </ng-container>
    </div>
    <div class="row-text empty-column" #optionsIcon>
        <mat-icon
            svgIcon="more-options"
            data-cy="exh-gas-setting-table-kebab-icon"
            class="icon"
            [class.disabled]="!canEditVessel()"
            (click)="openOptions()" />

        <ng-container *ngIf="optionsSettingOpen">
            <div
                class="more-options-container"
                #otherOptions
                [ngStyle]="{
                    top: editRowTop ? editRowTop : 'unset',
                    right: editRowRight ? editRowRight : 'unset',
                }">
                <div
                    class="option-text"
                    data-cy="exh-gas-setting-table-duplicate-button"
                    [class.disabled]="isAddSettingDisabled"
                    (click)="duplicateRow()">
                    {{ 'exhaust-settings.option.duplicate' | translate }}
                </div>
                <div class="option-text" data-cy="exh-gas-setting-table-delete-button" (click)="deleteRow()">
                    {{ 'exhaust-settings.option.delete' | translate }}
                </div>
            </div>
        </ng-container>
    </div>
</div>

<ng-template #infoMessage>
    <div class="info-message-container" [ngStyle]="{ top: infoMessageDistance ? infoMessageDistance : 'unset' }">
        <div>
            {{ 'exhaust-setting.title.temp-avg.info-1' | translate }}
        </div>
        <br />
        <div>
            {{ 'exhaust-setting.title.temp-avg.info-2' | translate }}
        </div>
    </div>
</ng-template>

<app-confirmation-window
    #removeConfirmation
    [mainLabel]="'exhaust-settings.remove.source'"
    [discardLabel]="'exhaust-settings.remove.source.cancel'"
    [saveLabel]="'exhaust-settings.remove.source.save'"
    [allButtonsLeft]="true"
    [inverseColors]="true">
</app-confirmation-window>
